import { TrainBadges } from "features/CenterContent/RoleContent/ProductionDeviation/components/TrainBadges";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { HStack, Text } from "shared/components/Spor";

type ShowTrainSeriesProps = {
  trainSeries: string[];
};

export const ShowTrainSeries: FC<ShowTrainSeriesProps> = ({ trainSeries }) => {
  const { t } = useTranslation();
  return (
    <HStack alignItems="center" w="100%">
      <Text>{t("Valgt togserie", { count: trainSeries.length })}:</Text>
      <TrainBadges trainIds={trainSeries} />
    </HStack>
  );
};
